import Member1 from "../../../assets/svg/avatar.svg";
// import Member2 from "../../../assets/svg/member-2.svg";
import PrivateMember from "../../../assets/svg/private-user.svg";
import { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { committeeActions } from "../../../_store/committee.slice";
import NoDataimg from "../../../assets/No_Data.png";
import { history } from "../../../_helpers";
import { ThreeDots } from "react-loader-spinner";

function CommitteeMemberPage() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.committee);
  const { committeeID } = useParams();
  const isFetchingNextPage = useRef(false);

  const [memberPages, setMemberPages] = useState({
    currentPage: 1,
    totalPages: 1,
    members: [],
    committeeChairList: [],
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (!committeeID) {
      navigate("/Committee");
    }
    loadMembers(1, true);
  }, [committeeID]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  // const loadMembers = async (page = 1, reset = false) => {
  //   const limit = 6;
  //   try {
  //     const res = await dispatch(
  //       committeeActions.getCommitteeMemberByCommitteeID({
  //         id: committeeID,
  //         page,
  //         limit,
  //         status: true,
  //       })
  //       // committeeActions?.getCommitteeMemberByCommitteeID(committeeData?._id)
  //     ).unwrap();

  //     const newMembers = res?.data?.users || [];
  //     const committeeChairList = res?.data?.committeeChairList || [];

  //     setMemberPages((prev) => {
  //       const updatedMembers = reset
  //         ? newMembers
  //         : [...prev.members, ...newMembers];

  //       return {
  //         members: updatedMembers,
  //         committeeChairList: committeeChairList,
  //         currentPage: res?.data?.currentPage || page,
  //         totalPages: res?.data?.totalPages || prev.totalPages,
  //       };
  //     });
  //   } catch (err) {
  //     console.error("Failed to load members:", err);
  //   }
  // };

  // const handleScroll = (e) => {
  //   debugger;
  //   const el = e.target;
  //   const isBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

  //   if (isBottom && memberPages.currentPage < memberPages.totalPages) {
  //     const nextPage = memberPages.currentPage + 1;
  //     if (memberPages.currentPage < nextPage) {
  //       loadMembers(memberPages.currentPage + 1);
  //     }
  //   }

  //   // Only load next page if not already loaded

  //   // Do nothing when scrolling up — because we already have previous data
  // };

   const loadMembers = async (page = 1, reset = false) => {
    if (isFetchingNextPage.current) return; // 🚫 already loading next page
    isFetchingNextPage.current = true;

    const limit = 6;
    try {
      const res = await dispatch(
        committeeActions.getCommitteeMemberByCommitteeID({
          id: committeeID,
          page,
          limit,
          status: true,
        })
      ).unwrap();

      const newMembers = res?.data?.users || [];
      const committeeChairList = res?.data?.committeeChairList || [];

      setMemberPages((prev) => {
        const updatedMembers = reset
          ? newMembers
          : [...prev.members, ...newMembers];
        return {
          members: updatedMembers,
          committeeChairList: committeeChairList,
          currentPage: res?.data?.currentPage || page,
          totalPages: res?.data?.totalPages || prev.totalPages,
        };
      });
    } catch (err) {
      console.error("Failed to load members:", err);
    } finally {
      isFetchingNextPage.current = false; // ✅ allow next load again
    }
  };
   const handleScroll = (e) => {
    const el = e.target;
    const isBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

    if (
      isBottom &&
      memberPages.currentPage < memberPages.totalPages &&
      !isFetchingNextPage.current // ✅ prevent double triggers
    ) {
      loadMembers(memberPages.currentPage + 1);
    }
  };

  const ImageURL = process.env.REACT_APP_API_IMAGE_URL + "/";
  return (
    <>
      {/* <section className="members-section">
        <div className="container">
          <h2 className=" main-title">Members</h2>
          <p className="mb-4">
            The board of the Broward Children’s Strategic Plan is diverse across
            multiple dimensions, including race, ethnicity, geographic
            representation, gender, and age. The board includes service
            providers, educators, community organizers, and subject-matter
            experts. At least one quarter of the members are individuals with
            lived experience relevant to the plan’s focus areas. All members are
            dedicated advocates for the well-being and future of children in
            Broward County.
          </p>

          <div
            className="row"
            onScroll={(e) => handleScroll(e)}
            style={
              memberPages?.members?.length > 4
                ? { maxHeight: "300px", overflowY: "auto" }
                : {}
            }
          >
            {memberPages?.members?.length > 0 ? (
              <>
                {memberPages?.members?.map((member, index) => {
                  return (
                    <div className="col-md-6" key={index}>
                      <div
                        className={`member-card ${
                          member?.privateMember ? "bg-light text-muted" : ""
                        }`}
                        title={
                          member?.privateMember
                            ? "This member’s details are private"
                            : ""
                        }
                      >
                        <img
                          src={!member?.privateMember ? Member1 : PrivateMember}
                          className="member-img"
                          alt="Maria Torres"
                        />
                        <div className="member-info">
                          <h6>
                            {member?.privateMember === true
                              ? "Private Member"
                              : member?.firstName + " " + member?.lastName}{" "}
                            <span className="designation">
                              {!member?.privateMember &&
                                (member?.role === 3
                                  ? "Super Admin"
                                  : member?.role === 2
                                  ? "Chair"
                                  : "Member")}
                            </span>
                          </h6>
                          <p>
                            {!member?.privateMember &&
                              (member?.organization
                                ? member?.organization
                                : "Miami-Dade Children's Trust")}
                            <br />
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {loading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <ThreeDots
                      height="180"
                      width="160"
                      color="#4fa94d"
                      visible={true}
                    />
                  </div>
                )}
              </>
            ) : (
              <section className="sign-in-section">
                <div className="container error-page-box">
                  <div className="p-5 d-flex flex-column justify-content-center align-items-center">
                    <img src={NoDataimg} alt="404" />
                    <h2 className="error-page-label">No Members Found</h2>
                    <button
                      onClick={() => {
                        history?.navigate("/Home");
                      }}
                      type="submit"
                      className="sign-in-button"
                    >
                      Back to Home
                    </button>
                  </div>
                </div>
              </section>
            )}
          </div>
        </div>
      </section> */}
      {/* {console.log("chk", loading)} */}

      {memberPages?.members?.length > 0 ||
      memberPages?.committeeChairList?.length > 0 ? (
        <>
          <section className="members-section">
            <div className="container commmittee-member-tab">
              <h2 className=" main-title">Members</h2>
              <p className="mb-4">
                The board of the Broward Partnerships for Kids is diverse across
                multiple dimensions, including race, ethnicity, geographic
                representation, gender, and age. The board includes service
                providers, educators, community organizers, and subject-matter
                experts. At least one quarter of the members are individuals
                with lived experience relevant to the plan’s focus areas. All
                members are dedicated advocates for the well-being and future of
                children in Broward County.
              </p>
              <div
                className="row"
                onScroll={(e) => handleScroll(e)}
                style={
                  memberPages?.members?.length > 4
                    ? { maxHeight: "300px", overflowY: "auto" }
                    : {}
                }
              >
                {/* chair card only */}
                {memberPages?.committeeChairList?.length > 0 &&
                  memberPages?.committeeChairList?.map((chair, index) => {
                    return (
                      <div className="col-md-6" key={index}>
                        <div
                          className={`member-card ${
                            chair?.privateMember ? "bg-light text-muted" : ""
                          }`}
                          title={
                            chair?.privateMember
                              ? "Only visible to authorized users"
                              : ""
                          }
                        >
                          <img
                            height="80px"
                            width="80px"
                            src={
                              chair?.privateMember
                                ? PrivateMember
                                : chair?.photo
                                ? ImageURL + chair?.photo
                                : Member1
                            }
                            className="member-img"
                            alt="Maria Torres"
                          />
                          <div className="member-info">
                            {chair?.privateMember === true ? (
                              <>
                                <h6>
                                  {chair?.firstName + " " + chair?.lastName}{" "}
                                  <p>Private Member</p>
                                </h6>
                                 <h6 className="member-card-email">{chair?.email}</h6>
                              </>
                            ) : (
                              <>
                                <h6>
                                  {chair?.firstName + " " + chair?.lastName}{" "}
                                  <span className="designation">Chair</span>
                                </h6>
                                 <h6 className="member-card-email">{chair?.email}</h6>
                              </>
                            )}

                            <p>
                              {!chair?.privateMember &&
                                (chair?.organization
                                  ? chair?.organization
                                  : "")}
                              <br />
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                {memberPages?.members?.map((member, index) => {
                  return (
                    <div className="col-md-6" key={index}>
                      <div
                        className={`member-card ${
                          member?.privateMember ? "bg-light text-muted" : ""
                        }`}
                        title={
                          member?.privateMember
                            ? "Only visible to authorized users"
                            : ""
                        }
                      >
                        <img
                          // src={!member?.privateMember ? Member1 : PrivateMember}
                          height="80px"
                          width="80px"
                          src={
                            member?.privateMember
                              ? PrivateMember
                              : member?.photo
                              ? ImageURL + member?.photo
                              : Member1
                          }
                          className="member-img"
                          alt="Maria Torres"
                        />
                        <div className="member-info">
                          {member?.privateMember === true ? (
                            <>
                              <h6>
                                {member?.firstName + " " + member?.lastName}{" "}
                              
                                <p>Private Member</p>
                              </h6>
                               <h6 className="member-card-email">{member?.email}</h6>
                               
                            </>
                          ) : (
                            <>
                              <h6>
                                {member?.firstName + " " + member?.lastName}{" "}
                                 
                                <span className="designation">
                                  {/* {member?.role === 3
                                    ? "Super Admin"
                                    : member?.role === 2
                                    ? "Chair"
                                    : "Member"} */}
                                  Member
                                </span>
                              </h6>
                              <h6 className="member-card-email">{member?.email}</h6>
                              
                            </>
                          )}
                          {/* <h6>
                            {member?.privateMember === true
                              ? "Private Member"
                              : member?.firstName + " " + member?.lastName}{" "}
                            <span className="designation">
                              {!member?.privateMember &&
                                (member?.role === 3
                                  ? "Super Admin"
                                  : member?.role === 2
                                  ? "Chair"
                                  : "Member")}
                            </span>
                          </h6> */}
                          <p>
                            {!member?.privateMember &&
                              (member?.organization
                                ? member?.organization
                                : "")}
                            <br />
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* {loading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <ThreeDots
                      height="180"
                      width="160"
                      color="#4fa94d"
                      visible={true}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </section>
        </>
      ) : (
        loading === false && (
          <div className="sign-in-section">
            <div className="container">
              <div className="login-container">
                <div className="error-page-box p-5 d-flex flex-column justify-content-center align-items-center">
                  <img src={NoDataimg} alt="404" />
                  <h2 className="error-page-label">No Member Found</h2>
                  <button
                    onClick={() => {
                      history?.navigate("/Home");
                    }}
                    type="submit"
                    className="sign-in-button"
                  >
                    Back to Home
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      )}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <ThreeDots height="180" width="160" color="#4fa94d" visible={true} />
        </div>
      )}
    </>
  );
}

export default CommitteeMemberPage;
